import URL from 'url-parse';

/**
 * The query flag that brings the artist back to the upload dialog after the SoundCloud sign-in
 * (design b2 note: "the returnTo brings the user back to the page of the panel, and c3 opens
 * again"). The panel reads it one time and drops it from the address.
 */
export const SOUNDCLOUD_UPLOAD_PARAM = 'soundCloudUpload';

/** This page with the flag: the `returnTo` of `auth/begin`. */
export function soundCloudUploadReturnTo(href: string): string {
  const url = new URL(href, true);
  url.set('query', { ...url.query, [SOUNDCLOUD_UPLOAD_PARAM]: '1' });
  url.set('hash', '');
  return url.toString();
}
